import BaseService from '../base';

class Mutual extends BaseService {}

export default new Mutual('mutuals', 'Mutual');
